var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 10.7493C25.8962 10.7493 26.7921 11.0915 27.4753 11.7743L48.9742 33.2734C50.3418 34.641 50.3418 36.8584 48.9742 38.2254C47.6072 39.5925 45.3903 39.5925 44.0225 38.2254L25.0001 19.2019L5.97747 38.2248C4.60986 39.5918 2.39318 39.5918 1.02624 38.2248C-0.342035 36.8577 -0.342035 34.6404 1.02624 33.2728L22.5248 11.7737C23.2083 11.0907 24.1043 10.7493 25.0001 10.7493Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.d4e888b0978817263538e36e499d2b80.svg";
export { ForwardRef as ReactComponent };